export default {"src":"/_next/static/media/customer-os-logo.57542b5d.svg","height":70,"width":322};